module.exports = __webpack_public_path__ + "img/zxmrk.a1727988.png";